import React from 'react';
import BottomActionBar from '../../../../components/BottomActionBar';
import { formatCurrency } from '../../../../utils/formatNumbers';
import { Text, WrapperText } from './style';
import { OptionsProps } from './CartProductTable';
import { addToast } from '../../../../store/ducks/toast/actions';
import { EToastTypes } from '../../../../store/ducks/toast/types';
import { useDispatch } from 'react-redux';

interface SummaryBottomProps {
  totalPrice: string;
  loading: boolean;
  hasProducts: boolean;
  showLoadNewPriceButton?: boolean;
  goToCheckout?: boolean;
  onLoadNewPrice: (props: OptionsProps) => void;
  handlePrevious: () => void;
  handleNext: () => void;
}

const SummaryText = ({
  totalPrice,
  showLoadNewPriceButton
}: {
  totalPrice: string;
  showLoadNewPriceButton?: boolean;
}) => {
  if (showLoadNewPriceButton) {
    return (
      <WrapperText>
        <span style={{ color: '#FF7703', fontSize: '14px' }}>
          Configurações alteradas. Atualize o preço do seu pedido.
        </span>
      </WrapperText>
    );
  }
  return (
    <WrapperText>
      <b>Preço total: R${totalPrice}</b>
      <Text style={{ margin: 0 }}>
        O preço pode sofrer alterações. Fale com o seu vendedor.
      </Text>
    </WrapperText>
  );
};

export const SummaryBottom = ({
  totalPrice,
  loading,
  hasProducts,
  handlePrevious,
  handleNext,
  onLoadNewPrice,
  showLoadNewPriceButton,
  goToCheckout
}: SummaryBottomProps) => {
  if (loading || !hasProducts) {
    return null;
  }

  const [showToast, setShowToast] = React.useState(false);

  React.useEffect(() => {
    if (!showLoadNewPriceButton) {
      setShowToast(false);
    }
  }, [showLoadNewPriceButton]);

  const dispatch = useDispatch();

  if (!showToast && showLoadNewPriceButton && !goToCheckout) {
    setShowToast(true);
    dispatch(
      addToast({
        type: EToastTypes.WARNING,
        message: 'Configurações de produto alteradas.',
        durationInMS: 3000,
        labelActionOne: 'Atualizar preços',
        handleClickActionOne: () => {
          setShowToast(false);
          onLoadNewPrice({ updatePrice: true });
        }
      })
    );
  }

  return (
    <BottomActionBar
      {...(showLoadNewPriceButton &&
        onLoadNewPrice && {
          thirdBtn: {
            fn: () => {
              setShowToast(false);
              onLoadNewPrice({ updatePrice: true });
            },
            name: 'thirdBtn',
            text: 'Atualizar preços',
            disabled: loading,
            fullWidth: true
          }
        })}
      previousBtn={{
        fn: handlePrevious,
        name: 'previousBtn',
        text: 'Adicionar produtos',
        disabled: loading
      }}
      nextBtn={{
        fn: handleNext,
        name: 'nextBtn',
        text: 'Avançar para revisão',
        disabled: loading
      }}
    >
      <SummaryText
        totalPrice={formatCurrency(totalPrice)}
        showLoadNewPriceButton={showLoadNewPriceButton}
      />
    </BottomActionBar>
  );
};
